import { render, staticRenderFns } from "./ProductSingleComponents.vue?vue&type=template&id=6887ac67&"
import script from "./ProductSingleComponents.vue?vue&type=script&lang=js&"
export * from "./ProductSingleComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports